import React from 'react';

export default function Footer() {
  return (
    <footer
      className="fixed bottom-0 left-0 right-0 z-40 flex items-center justify-center gap-8 px-8 py-4"
      style={{ borderTop: '1px solid rgba(184, 175, 166, 0.3)' }}
    >
      <span
        className="font-plex-mono"
        style={{ fontSize: '10px', letterSpacing: '0.2em', color: 'var(--tatami)', textTransform: 'uppercase' }}
      >
        © 2026 Abroad
      </span>
      <span style={{ color: 'var(--tatami-light)', fontSize: '10px' }}>·</span>
      <a
        href="#"
        className="font-plex-mono transition-colors duration-200"
        style={{ fontSize: '10px', letterSpacing: '0.2em', color: 'var(--tatami)', textTransform: 'uppercase', textDecoration: 'none' }}
        onMouseEnter={e => (e.currentTarget.style.color = 'var(--sumi)')}
        onMouseLeave={e => (e.currentTarget.style.color = 'var(--tatami)')}
      >
        Privacy
      </a>
      <span style={{ color: 'var(--tatami-light)', fontSize: '10px' }}>·</span>
      <a
        href="#"
        className="font-plex-mono transition-colors duration-200"
        style={{ fontSize: '10px', letterSpacing: '0.2em', color: 'var(--tatami)', textTransform: 'uppercase', textDecoration: 'none' }}
        onMouseEnter={e => (e.currentTarget.style.color = 'var(--sumi)')}
        onMouseLeave={e => (e.currentTarget.style.color = 'var(--tatami)')}
      >
        Terms
      </a>
    </footer>
  );
}